import '../Styles/UMAPStyles.css';
import { Component } from 'preact';
import Form from 'react-bootstrap/Form';
import { index } from 'd3';
import Checkbox from 'preact-material-components/Checkbox';
import Formfield from 'preact-material-components/FormField';
import 'preact-material-components/Checkbox/style.css';

import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import createScatterplot from 'regl-scatterplot';

class UmapComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      switchHighlighted:false, //swicth "Only Highlighted Data"
      switchContours:false,
      xMin:1000,
      xMax:-1000,
      yMin:1000,
      yMax:-1000,
      flag:0,
    }
    this.updateNoSelectData = this.updateNoSelectData.bind(this);
    this.updateDetritalData = this.updateDetritalData.bind(this);
    this.hdlDonwload = this.hdlDonwload.bind(this);
  }
  /*is invoked immediately after a component is mounted*/
  componentDidMount(){
    // set the dimensions and margins of the graph
    // set the dimensions and margins of the graph
    var margin = {top: 10, right: 10, bottom: 10, left: 10},
    width = (screen.width>1800)? 500:400,
    height = (screen.width>1800)? 500:280;


    // append the svg object to the body of the page
    var svg = d3.select("#overlay-focus")
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .append("g")
    .attr("width", width)
    .attr("height", height)
    .style('transform', 'translate(0%, 0%)')

  }
  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){
    if(!(prevProps.filteredData_panel.length == this.props.filteredData_panel.length)){
      this.updateNoSelectData(this.props.optionDropDown);
    }

    if(!(prevProps.filteredData_projection.length == this.props.filteredData_projection.length) ||
    !(prevProps.filteredData_umap.length == this.props.filteredData_umap.length)){
      this.updateNoSelectData(this.props.optionDropDown);
      this.updateDetritalData(this.props.optionDropDown);
    }

    if(!(prevProps.optionDropDown==this.props.optionDropDown)){
      this.updateNoSelectData(this.props.optionDropDown);
    }

    if((this.props.filteredData_umap.length>0) && !(prevProps.umap_detrital == this.props.umap_detrital))
    this.updateDetritalData(this.props.optionDropDown);

    this.updateNoSelectData(this.props.optionDropDown);
    this.updateSelectDetritalData(this.props);

  }

  hdlDonwload(){
    /*
    let fig1 = document.getElementById("umap-chart").getElementsByTagName('svg')[0];

    this.saveSVG(fig1, "umap.svg")*/
  }

  saveSVG(svgEl,name){
    svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    var svgData = svgEl.outerHTML;
    var preface = '<?xml version="1.0" standalone="no"?>\r\n';
    var svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
    var svgUrl = URL.createObjectURL(svgBlob);
    var downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  updateNoSelectData(option){
    var canvas = document.getElementById("umap-chart-focus"),
    ctx = canvas.getContext("2d");

    var margin = {top: 10, right: 10, bottom: 10, left: 10},
    width= 400,
    height= 280;

    if(screen.width>1800){
      width = 500;
      height = 350;
    }
    canvas.width = width//document.getElementById("container-UMAP").offsetWidth-20;
    canvas.height = height; //document.getElementById("container-UMAP").offsetHeight-20;


    var umap_data = []; //coordenadas de puntos del umap segun la opcion elegida en dropdown (x,y,categoria)
    var data = this.props.complete_data; //necesario para SubCategoria de los puntos
    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])
    //.range(["#ED1909","#F56101", "#1E90FF", "#41A321", "#0087F5", "#02318A","#833D9F", "#F59FD7"])

    var categoryOrder = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range([0,1,2,3,4,5,6,7])

    const subcats = [[],
    ["alkali basalt etc","kimberlite","lamproite"],
    ["boninite","flood basalt","hawaii lava lake","island arc","ocean floor","ocean island"],
    ["chromite cores amphibolite AUDK","chromite cores amphibolite ADK","chromite cores greenschist","sulphide"],
    ["chromitite","other","subvolc sills/dykes"],
    ["magnetite rims amphibolite","magnetite rims greenschist"],
    ["chromitite","high p alpine","ocean floor peridotite","chromite"],
    ["basalts","kimberlites","ocean floor"]];


    let umap_data_selecc = [];
    this.props.filteredData_projection.forEach((item, i) => {
      umap_data_selecc.push(this.props.umap_data[option][this.props.filteredData_projection[i]]);
    });
    this.props.filteredData_umap.forEach((item, i) => {
      umap_data_selecc.push(this.props.umap_data[option][this.props.filteredData_umap[i]]);
    });

    var xMin = d3.extent(umap_data_selecc.map(l=>l.umap1))[0];
    var xMax = d3.extent(umap_data_selecc.map(l=>l.umap1))[1];
    var yMin = d3.extent(umap_data_selecc.map(l=>l.umap2))[0];
    var yMax = d3.extent(umap_data_selecc.map(l=>l.umap2))[1];

    umap_data_selecc.forEach(function(item, i) {
      umap_data.push({i:item.i,umap1:((item.umap1-xMin)/(xMax-xMin)),umap2:((item.umap2-yMin)/(yMax-yMin)),Category:item.Category});
    });

    const subcategoryQuery = (id) =>{
      return data[id].Category2;
    };


    let switchHighlighted = this.state.switchHighlighted;
    let filteredData_projection = this.props.filteredData_projection;
    let filteredData_umap = this.props.filteredData_umap;
    //d3.select("#container").select("svg").remove(); //remuevo el contenido

    ctx.strokeStyle = "rgba(0,100,160,0.24)"; //color para el foreground

    var margin = {top: 10, right: 10, bottom: 10, left: 10},
    width = canvas.width,
    height = canvas.height;

    // Tamaño del punto en el scatterplot
    var pointSize = 2;

    // Add X axis
    var x = d3.scaleLinear()
    .domain([0, 1])
    .range([ 0+margin.left, width-margin.right]);

    // Add Y axis
    var y = d3.scaleLinear()
    .domain([0, 1])
    .range([ height-margin.bottom, 0+margin.top]);

    // Dibuja el scatterplot
    function drawScatterplot() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      //Datos seleccionados
      for (var i = 0; i < umap_data.length; i++) {
        var point = umap_data[i];
        if(!filteredData_projection.includes(point.i)){ //Si no esta seleccionado en projections
          var c,cs;
          ctx.beginPath();
          ctx.arc(x(point.umap1), y(point.umap2), pointSize, 0, 2 * Math.PI);
          if(subcats[categoryOrder(point.Category)].length==0)
          c =  scaleColor(point.Category); //Alkali y Laterite
          else {
            var n = subcats[categoryOrder(point.Category)].length; //cantidad de subcategorias
            var color = d3.hsl(scaleColor(point.Category));
            var nsub =  subcats[categoryOrder(point.Category)].indexOf(subcategoryQuery(point.i))+2; //por lo que se encuentra en la pos 0
            c = d3.hsl(color.h, ((0.8-0.2)/(n+1))*nsub + 0.2  , ((0.8-0.2)/(n+1))*nsub + 0.2);
          };
          ctx.globalAlpha = 0.4;
          ctx.fillStyle = c;
          ctx.fill();
          ctx.globalAlpha = 1;
          ctx.lineWidth = 0;
          ctx.closePath();
        }
      }

      for (var i = 0; i < umap_data.length; i++) {
        var point = umap_data[i];
        if(filteredData_projection.includes(point.i)){ //Si esta seleccionado en projections
          var c,cs;
          ctx.beginPath();
          ctx.arc(x(point.umap1), y(point.umap2), pointSize, 0, 2 * Math.PI);
          if(subcats[categoryOrder(point.Category)].length==0)
          c =  scaleColor(point.Category); //Alkali y Laterite
          else {
            var n = subcats[categoryOrder(point.Category)].length; //cantidad de subcategorias
            var color = d3.hsl(scaleColor(point.Category));
            var nsub =  subcats[categoryOrder(point.Category)].indexOf(subcategoryQuery(point.i))+2; //por lo que se encuentra en la pos 0
            c = d3.hsl(color.h, ((0.8-0.2)/(n+1))*nsub + 0.2  , ((0.8-0.2)/(n+1))*nsub + 0.2);
          };
          ctx.globalAlpha = 0.8;
          ctx.fillStyle = c;
          ctx.fill();
          ctx.strokeStyle = "#B90E0A";
          ctx.lineWidth = 0.4;
          ctx.stroke();
          ctx.closePath();
        }
      }
    }
    drawScatterplot();

  }


  updateDetritalData(option){
    if(this.state.flag == 0) {this.updateNoSelectData(option);this.setState({flag:1})};
    d3.select("#overlay-focus").selectAll(".detrital").remove()

    var svg = d3.select("#overlay-focus")
    .select("svg").select("g")

    var margin = {top: 10, right: 10, bottom: 10, left: 10},
    width= 400,
    height= 280;

    if(screen.width>1800){
      width = 500;
      height = 350;
    }




    // Add X axis
    var x = d3.scaleLinear()
    .domain([0, 1])
    .range([ 0+margin.left, width-margin.right]);

    // Add Y axis
    var y = d3.scaleLinear()
    .domain([0, 1])
    .range([ height-margin.bottom, 0+margin.top]);



    let umap_detrital = [],detritalId = [];
    let umap_data_selecc = [];
    this.props.filteredData_projection.forEach((item, i) => {
      umap_data_selecc.push(this.props.umap_data[option][this.props.filteredData_projection[i]]);
    });
    this.props.filteredData_umap.forEach((item, i) => {
      umap_data_selecc.push(this.props.umap_data[option][this.props.filteredData_umap[i]]);
    });

    var xMin = d3.extent(umap_data_selecc.map(l=>l.umap1))[0];
    var xMax = d3.extent(umap_data_selecc.map(l=>l.umap1))[1];
    var yMin = d3.extent(umap_data_selecc.map(l=>l.umap2))[0];
    var yMax = d3.extent(umap_data_selecc.map(l=>l.umap2))[1];

    this.props.umap_detrital.forEach(function(item, i) {
      if(!detritalId.includes(item.id))
      detritalId.push(item.id);
      umap_detrital.push({
        i:item.i,
        Ref:item.Ref,
        umap1:(item.umap1-xMin)/(xMax-xMin),
        umap2:(item.umap2-yMin)/(yMax-yMin),
        cat:item.Category,
        id:item.id});
      });

      //detrital
      // Add dots
      const symbol = [d3.symbolCross,d3.symbolSquare,d3.symbolCircle,d3.symbolDiamond2, d3.symbolTriangle, d3.symbolStar, d3.symbolCircle,d3.symbolCross];
      let filteredData_detrital = this.props.filteredData_detrital;

      var detrital = svg.append('g')
      .selectAll("dot")
      .data(umap_detrital)
      .enter()
      .append("path")
      .attr("class", "detrital")
      .attr("d", d3.symbol().type( function(d,i){
        return symbol[d.id];
      }).size(30))
      .attr("transform", function(d) { return "translate(" + x(d.umap1) + "," + y(d.umap2) + ")"; })
      .style("fill",function(d,i){
        if(filteredData_detrital.includes(d.i)) return  "#FFFFFF";
        else return "#000000";
      })
      .style("stroke",function(d,i){
        if(filteredData_detrital.includes(d.i)) return  "#000000";
        else return null;
      })
      .on("click", (d, i, nodes) => {
        if(event.ctrlKey) {
          if(d3.select(nodes[i]).style("stroke")=="#000000"){ //Si el detrito ya esta seleccionado
            d3.select(nodes[i])
            .style("fill","rgba(0, 0, 0, 1)")
            .style("stroke", null)
          }
          else {
            d3.select(nodes[i])
            .style("fill","rgba(255, 255, 255, 1)")
            .style("stroke", "#000000")
          }
          clkSeleccDetrital(d.i);
        }
      });

      const clkSeleccDetrital=(d)=>{
        this.props.clkSeleccDetrital(d);
      }


    }

    updateSelectDetritalData(props){
      let filteredData_detrital = props.filteredData_detrital;

      d3.select("#overlay-focus").selectAll(".detrital")
      .style("fill",function(d,i){
        if(filteredData_detrital.includes(d.i)) return  "#FFFFFF";
        else return "#000000";
      })
      .style("stroke",function(d,i){
        if(filteredData_detrital.includes(d.i)) return  "#000000";
        else return null;
      })
      .classed("selected_detrital",function(d,i){
        if(filteredData_detrital.includes(d.i)) return  true;
        else{
          return false;
        }
      })
      d3.select("#overlay-focus").selectAll(".selected_detrital").raise();
    }

    updateDetritalLegend(props){

      d3.select("#legendDetrital").selectAll("*").remove()

      let detritalId = [];
      props.umap_detrital.forEach(function(item, i) {
        if(!detritalId.includes(item.id))
        detritalId.push(item.id);
      });

      const symbol = [d3.symbolCross,d3.symbolSquare,d3.symbolCircle,d3.symbolDiamond2, d3.symbolTriangle, d3.symbolStar, d3.symbolCircle,d3.symbolCross];

      var svglegend = d3.select("#legendDetrital")
      .append("svg")
      .attr("width", "100%")
      .attr("height", "100%")
      .append("g")
      .attr("transform",
      "translate(" + 0 + "," + 5 + ")");



      detritalId.forEach((item, i) => {
        svglegend
        .append("path")
        .attr("class", "legendDetrital")
        .attr("d", d3.symbol().type( function(d,i){
          return symbol[item];
        }).size(20))
        .attr("transform", function(d) { return "translate(" + 10 + "," + 18*(i+1) + ")"; })
        .style("fill", "#000000")
        .style("stroke-width", 0)

        svglegend.append("text").attr("x", 30).attr("y", 18*(i+1))
        .text("group "+i)
        .attr("class", "node-label")
        //.style("font-size", "1rem")
        //.style("font-family", 'Nunito, sans-serif')
        //.attr("font-weight",700)
        //.attr("alignment-baseline","middle")
      });
    }


    render(){
      return (
        <div id="container-UMAP-focus">
        <canvas id="umap-chart-focus"></canvas>
        <div id="overlay-focus"></div>
        </div>
      );
    }
  }
  /*

  <text class="textSwitch" >Colorize unselected items</text>

  <Switch checked={this.state.switch} onChange={e =>{this.setState({switch:!this.state.switch},()=>this.update_UMAP(this.props.dropDownOption)); }}/>
  */
  export default UmapComponent;
